import SidePanelSection from "components/shared-ui/side-panel-section/side-panel-section";
import React, { useEffect, useState } from "react";
import { TimeRangeSelection } from "./time-range-selection";
import styles from "./blackout-section.module.scss";
import { IBucketV2BlackoutEntry } from "api/entities/blackout";
import { DateTime } from "luxon";
import { IconButton } from "@mui/material";
import { Delete } from "@mui/icons-material";

export interface IBucketV2BlackoutSectionProps {
  disabled?: boolean;
  className?: string;
  activeRestorePoint?: IBucketV2BlackoutEntry;
  onChange: (value: DateTime) => void;
  onClear: () => void;
  onError: (error: IBucketV2BlackoutSectionErrors) => void;
}

export interface IBucketV2BlackoutSectionErrors {
  maxTime?: string;
}

const sectionDescription =
  "Adding a restore point will exclude all changes made to this bucket after the selected time.";

export function BucketV2BlackoutSection(props: IBucketV2BlackoutSectionProps) {
  const [error, setError] = useState<IBucketV2BlackoutSectionErrors>();

  const handleError = (message?: string) => {
    if (message) {
      setError({ maxTime: message });
      return;
    }

    setError({maxTime: undefined});
  };

  useEffect(() => {
    props.onError(error);
  }, [error]);

  const getFormattedRestorePoint = (value: IBucketV2BlackoutEntry) => {
    return `${DateTime.fromISO(props.activeRestorePoint.Begin).toLocaleString(
      DateTime.DATETIME_SHORT_WITH_SECONDS,
    )} - ${DateTime.fromISO(props.activeRestorePoint.End).toLocaleString(
      DateTime.DATETIME_SHORT_WITH_SECONDS,
    )}`;
  };

  return (
    <SidePanelSection
      title="Data Recovery"
      testId="blackout-section"
      className={props.className}
      description={sectionDescription}
    >
      <div className={styles.container}>
        <div className={styles["label-container"]}>
          <div className={styles.label}>Active Restore Point:</div>

          <div>
            <span className={styles.value}>
              {props.activeRestorePoint
                ? getFormattedRestorePoint(props.activeRestorePoint)
                : "none"}
            </span>
          </div>
          {props.activeRestorePoint && (
            <IconButton size="small" onClick={props.onClear}>
              <Delete />
            </IconButton>
          )}
        </div>
        <TimeRangeSelection onchange={props.onChange} onError={handleError} />
      </div>
    </SidePanelSection>
  );
}
